import { API_ENDPOINT, IS_BROWSER, IS_PROD } from "@config/consts";

import { AVAILABLE_COUNTRIES, ORIGIN } from "@typings/globals";

const getApiUrl = (
  langOrScope = "en",
  version = "v1",
  fallbackUrl = API_ENDPOINT,
): string => {
  if (!IS_BROWSER) {
    return fallbackUrl;
  }

  const host = location.host;
  const isLocalhost = location.host.startsWith("localhost");
  const isLocalIp =
    location.host.startsWith("192") || location.host.startsWith("10");

  if (IS_PROD || isLocalhost || isLocalIp) {
    return fallbackUrl;
  }

  const apiEnv = process.env.API_ENV;
  const app = process.env.APP as ORIGIN;
  const domain = getStagingDomainByApp(app);
  const tld = getStagingTldByHost(host);

  return `https://${apiEnv}.${domain}.${tld}/${langOrScope}/api/${version}`;
};

function getStagingDomainByApp(app?: ORIGIN) {
  switch (app) {
    case "batmaid":
      return "elpster";
    default:
      console.error("Unknown app; Add APP variable to .env");
      return "elpster";
  }
}

function getStagingTldByHost(host: string) {
  // TODO: extract mapping to const and reuse in `ResolveCountryFromUrl`
  const map = {
    "local.batmaid.ch": "club",
    "local.batmaid.pl": "world",
    "local.batmaid.fr": "pro",
    "local.batmaid.lu": "xyz",
    "local.batmaid.de": "space",
    "local.batmaid.it": "life",
    "local.batmaid.at": "art",
    "local.batmaid.be": "casa",
    "local.batmaid.nl": "work",
    "local.batmaid.uk": "in",
  };

  let tld;

  Object.entries(map).forEach(([originPrefix, target]) => {
    if (host.startsWith(originPrefix)) {
      tld = target;
    }
  });

  return tld || "club";
}

export { getApiUrl };
